export const invoicePayTypeMap = {
  bank_transfer: 'Überweisung/Konto',
  ec: 'EC',
  cash: 'Bar',
  misc: 'sonstiges',
};

